import { DummyFieldStyled } from "./dummy-field.styles";
import { Typography } from "@mui/material";

const DummyField = ({
  label,
  value,
  startIcon,
  background,
  endContent,
  noGap,
  minWidth,
  fullWidth,
}) => {
  return (
    <DummyFieldStyled noGap={noGap}>
      {label && (
        <div className="label">
          <Typography variant="body1">{label}</Typography>
        </div>
      )}
      <div
        className="content"
        style={{
          backgroundColor: background,
          minWidth: fullWidth ? "100%" : minWidth,
          maxWidth: "100%",
        }}
      >
        {startIcon && startIcon}
        {!endContent && <Typography variant="body1">{value}</Typography>}
        {endContent && endContent}
      </div>
    </DummyFieldStyled>
  );
};

export default DummyField;
